const KEY = "steerly:post-checkout-download";

export function setDownloadIntent(): void {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* ignore */
  }
}

export function consumeDownloadIntent(): boolean {
  try {
    const v = sessionStorage.getItem(KEY) === "1";
    if (v) sessionStorage.removeItem(KEY);
    return v;
  } catch {
    return false;
  }
}
